export type LevelCounts = { info: number; warn: number; error: number }

/**
 * Quantos eventos descartar de cada nível para remover `toDelete` no total,
 * sacrificando primeiro `info`, depois `warn` e por último `error`.
 */
export function planTrim(toDelete: number, counts: LevelCounts): LevelCounts {
  let left = Math.max(0, toDelete)
  const plan: LevelCounts = { info: 0, warn: 0, error: 0 }
  for (const level of ['info', 'warn', 'error'] as const) {
    const take = Math.min(left, counts[level])
    plan[level] = take
    left -= take
  }
  return plan
}
